import React from "react";
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import NavBar from "./NavBar";
import dati from "../data/offertaProdotti.json"
import { useState,useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp,faArrowDown } from '@fortawesome/free-solid-svg-icons'
import Footer from "./Footer"
import SezioneProdotti from "./SezioneProdotti";
import { Link } from "react-router-dom";

export default function Catalogo(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });


    const [currentIndex,setCurrentIndex] = useState(0)
    
    function avanti(){
        const container = document.querySelector(".small-container");

        const childElements = container.querySelectorAll(".row");
        if(currentIndex < childElements.length -1){
            setCurrentIndex(currentIndex+1);
            container.scrollTo({
                left:childElements[currentIndex+1].offsetLeft,
                behavior:"smooth"
            });
        }else{
            setCurrentIndex(0);
            container.scrollTo({
                left:childElements[0].offsetLeft,
                behavior:"smooth"
            })
        }
    }
    function dietro(){

        const container = document.querySelector(".small-container");

        const childElements = container.querySelectorAll(".row");
        if(currentIndex > 0){
            setCurrentIndex(currentIndex-1);
            container.scrollTo({
                left:childElements[currentIndex-1].offsetLeft,
                behavior:"smooth"
            });
        }else{
            setCurrentIndex(childElements.length -1);
            container.scrollTo({
                left:childElements[childElements.length -1].offsetLeft,
                behavior:"smooth"
            })
        }
    }
    function handleSelect (e){
        console.log(e.target.value)
        try {   
            document.querySelector(`#${e.target.value}`).scrollIntoView();
        } catch (error) {
            return null;
        }
        
    }
    function figlioBossEntrata(id){
        const n1 = document.getElementById("figlioBossPrimo");
        const n2 = document.getElementById("figlioBossSecondo");
        if(id==="figlioBossPrimo"){
            hoverrato(n1,n2);
        }else{
            hoverrato(n2,n1);
        }
    }
    function figlioBossUscita(id){
        const n1 = document.getElementById("figlioBossPrimo");
        const n2 = document.getElementById("figlioBossSecondo");
        if(id==="figlioBossPrimo"){
            hoverratoTolto(n1,n2) ;
        }else{
            hoverratoTolto(n2,n1);
        }
    }
    function hoverrato(elem1,elem2){
        elem1.classList.add("heightA");
        elem1.classList.remove("heightATolto");
        elem1.classList.remove("heightZTolto");

        elem2.classList.add("heightZ");
        elem2.classList.remove("heightZTolto");
        elem2.classList.remove("heightATolto");
    }
    function hoverratoTolto(elem1,elem2){
        elem1.classList.remove("heightA");
        elem2.classList.remove("heightZ");
        elem1.classList.add("heightATolto");
        elem2.classList.add("heightZTolto");
        setTimeout(() => {
            elem1.classList.remove("heightATolto");
            elem2.classList.remove("heightZTolto");
        }, "510");   
    }


    return (
        <div className="prodottiBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno="Informazioni" due="Contattaci" tre="Catalogo" one="/informazioni" two="/contattaci" three="/catalogo"/>
            <div className="headerProdotti">

                <div className="backgroundProdotti offerta">
                    
                    <div className="evidenzaTitolo">
                            <h1>IN EVIDENZA</h1>
                    </div>
                    
                    <div className="offer">                 
                        <button id="bottoneDietro" className="bottone" onClick={dietro}  ><FontAwesomeIcon icon={faArrowLeft} /></button>
                    
                        <div className="small-container"> 

                            {
                                dati && dati.offerta.map((elem)=>

                                <div className="row" key={elem.urlLink}>
                                    <div className="col-2">                     
                                        
                                        <Link to={`../prodotti/${elem.urlLink[0]}-${elem.urlLink[1]}-${elem.urlLink[2]}-${elem.urlLink[3]}-${elem.titolo}`}>
                                            <img src={elem.immagine[0]} className="offer-img" alt="immagine"/>
                                        </Link>

                                    </div>
                                    <div className="col-2">
                                        <h1>{elem.titolo}</h1>
                                        <p>€{elem.prezzo}</p>
                                        <small>{elem.descrizione}</small>
                                        {/* <a href="" className="btn">Compra Ora &#8594;</a> */}
                                    </div>
                                </div>
                                )

                            }

                        </div>                              
                        <button id="bottoneAvanti" className="bottone" onClick={avanti}><FontAwesomeIcon icon={faArrowRight} /></button>
                    </div>
                    
                </div>

                <div className="figlioSecondo">
                    <div id="figlioBossPrimo" onMouseEnter={()=>figlioBossEntrata("figlioBossPrimo")} onMouseLeave={()=>figlioBossUscita("figlioBossPrimo")} className="figlioSecondoPrimo">
                        <div className="flexColumn">
                            {dati.banner1
                                .map((elem)=>
                                <Link
                                to={`../prodotti/${elem.urlLink[0]}-${elem.urlLink[1]}-${elem.urlLink[2]}-${elem.urlLink[3]}-${elem.titolo}`} 
                                state={[elem.immagine,elem.descrizione,elem.prezzo]}
                                key={crypto.randomUUID()}
                                >
                                    <img src={elem.immagine[0]} alt="Immagine" />
                                </Link>)
                            }

                            <h3><FontAwesomeIcon icon={faArrowDown} /><FontAwesomeIcon icon={faArrowDown} /></h3>
                        </div>   
                    </div>
                    <div id="figlioBossSecondo" onMouseEnter={()=>figlioBossEntrata("figlioBossSecondo")} onMouseLeave={()=>figlioBossUscita("figlioBossSecondo")} className="figlioSecondoSecondo ">
                        <div className="flexColumn flexColumn2">
                            
                            {dati.banner2
                                .map((elem)=>
                                <Link
                                to={`../prodotti/${elem.urlLink[0]}-${elem.urlLink[1]}-${elem.urlLink[2]}-${elem.urlLink[3]}-${elem.titolo}`} 
                                state={[elem.immagine,elem.descrizione,elem.prezzo]}
                                key={crypto.randomUUID()}
                                >
                                    <img src={elem.immagine[0]} alt="Immagine" />
                                </Link>)
                            }
                            <h3><FontAwesomeIcon icon={faArrowUp} />  <FontAwesomeIcon icon={faArrowUp} /></h3>
                        </div>
                    </div>
                </div>

            </div>

            <div style={{textAlign:"center",marginTop:"1vh",marginBottom:"8vh"}}>
                <select name="" id="dropDown" onChange={event=>handleSelect(event)}>
                    <option value="niente">Seleziona</option>
                    <option value="Telefono">Prodotti per cellulare</option>
                    <option value="Bigiotteria">Bigiotteria</option>
                </select>
            </div>

            {/** Prodotti divisi */}
            <div id="Telefono"></div>
            <SezioneProdotti  elemTitolo="Prodotti per Cellulare" elem1="Cover / Vetri Protettivi" elem2="Carica Batterie / Adattatori" elem3="USB / Schede SD" elem4="Cuffie / Powerbank" link1="/prodotti/cover-vetriProtettivi" link2="/prodotti/caricaBatterie-adattatori" link3="/prodotti/Usb-schedeSD" link4="/prodotti/cuffie-powerbank" classe="backgroundProdotti sfondoTelefoni fareSpazio" id="telefoni"/>

            
            <div id="Bigiotteria"></div>                   
            <SezioneProdotti elemTitolo="Bigiotteria" elem1="Orecchini" elem2="Collane" elem3="Anelli" elem4=" Braccialetti" link1="/prodotti/orecchini" link2="/prodotti/collane" link3="/prodotti/anelli" link4="/prodotti/braccialetti" classe="backgroundProdotti sfondoBigiotteria fareSpazio" id="bigiotteria"/>
                             
            <SezioneProdotti elemTitolo="In Allestimento..." elem1="Disponibile" elem2="A Presto" elem3="logo" elem4="logo" link1="" link2="" link3="" link4="" classe="backgroundProdotti sfondoAllestimento fareSpazio" id=""/>

            <Footer />
        </div>
    )
}